import { createContext } from "react";

export type ProjectUserRole = {
  userId: string;
  projectId: number;
  projectName: string | undefined;
  roleName: string;
  roleId: number;
}

export type TeamMemberColumnVisibility = {
  id: boolean;
  forename: boolean;
  surname: boolean;
  displayName: boolean;
  email: boolean;
  projectRole: boolean;
}
export type UserColumnVisibility = {
  id: boolean;
  forename: boolean;
  surname: boolean;
  displayName: boolean;
  email: boolean;
}

interface TeamBuilderContextProps {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  demoMode: boolean;
  toggleDemoMode: (enable: boolean) => void;
  showUserFilters: boolean;
  setShowUserFilters: (show: boolean) => void;
  showTeamFilters: boolean;
  setShowTeamFilters: (show: boolean) => void;
  userSelection: {};
  setUserSelection: React.Dispatch<React.SetStateAction<{}>>;
  teamMemberSelection: {};
  setTeamMemberSelection: React.Dispatch<React.SetStateAction<{}>>;
  HandleAddUserToTeam: (demoUserIds?: string[]) => void;
  HandleGroupRemoveClicked: () => void;
  setTourStateInitial: () => void;
  setTourStateWithUserAdded: () => void;
}

export const TeamBuilderContext = createContext<TeamBuilderContextProps>({
  dialogOpen: false,
  setDialogOpen: () => {},
  demoMode: false,
  toggleDemoMode: () => {},
  showUserFilters: false,
  setShowUserFilters: () => {},
  showTeamFilters: false,
  setShowTeamFilters: () => {},
  userSelection: {},
  setUserSelection: () => {},
  teamMemberSelection: {},
  setTeamMemberSelection: () => {},
  HandleAddUserToTeam: () => {},
  HandleGroupRemoveClicked: () => {},
  setTourStateInitial: () => {},
  setTourStateWithUserAdded: () => {},
});